import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Box,
  Chip,
  Stack,
} from "@mui/material";
import LocalDiningRoundedIcon from "@mui/icons-material/LocalDiningRounded";
import SoupKitchenRoundedIcon from "@mui/icons-material/SoupKitchenRounded";

const RecipeCard = ({ recipe }) => (
  <Card
    sx={{
      width: "100%",
      minHeight: 430,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      borderRadius: 3,
      overflow: "hidden",
      border: "1px solid rgba(249, 115, 22, 0.16)",
      background:
        "linear-gradient(180deg, rgba(255,255,255,0.98), rgba(255,251,235,0.98))",
      boxShadow: "0 18px 42px rgba(245, 158, 11, 0.16)",
      transition: "transform 0.25s ease, box-shadow 0.25s ease",
      "&:hover": {
        transform: "translateY(-6px)",
        boxShadow: "0 26px 54px rgba(249, 115, 22, 0.22)",
      },
    }}
  >
    <Box sx={{ position: "relative" }}>
      <CardMedia
        component="img"
        image={recipe.image}
        alt={recipe.title}
        sx={{ height: 210, width: "100%", objectFit: "cover" }}
      />
      <Chip
        icon={<SoupKitchenRoundedIcon />}
        label="Hot pick"
        sx={{
          position: "absolute",
          top: 16,
          left: 16,
          bgcolor: "rgba(255,248,235,0.92)",
          color: "primary.dark",
          fontWeight: 800,
        }}
      />
    </Box>

    <CardContent sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <Typography
        variant="h6"
        gutterBottom
        sx={{
          color: "text.primary",
          fontWeight: 800,
          minHeight: 64,
          display: "-webkit-box",
          overflow: "hidden",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
        }}
      >
        {recipe.title}
      </Typography>

      <Stack direction="row" spacing={1} sx={{ mb: 1.5 }}>
        <Chip
          size="small"
          label="Flavor-packed"
          sx={{ bgcolor: "rgba(56, 189, 248, 0.18)", color: "secondary.dark", fontWeight: 700 }}
        />
        <Chip
          size="small"
          label="Kitchen ready"
          sx={{ bgcolor: "rgba(250, 204, 21, 0.22)", color: "text.primary", fontWeight: 700 }}
        />
      </Stack>

      <Box sx={{ flexGrow: 1 }}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            display: "-webkit-box",
            overflow: "hidden",
            textOverflow: "ellipsis",
            WebkitLineClamp: 4,
            WebkitBoxOrient: "vertical",
            mb: 2,
            lineHeight: 1.7,
          }}
        >
          {Array.isArray(recipe.extendedIngredients)
            ? recipe.extendedIngredients.map((ing) => ing.name).join(", ")
            : "No ingredients available"}
        </Typography>
      </Box>

      <Button
        variant="outlined"
        color="primary"
        fullWidth
        href={recipe.sourceUrl}
        target="_blank"
        rel="noopener noreferrer"
        startIcon={<LocalDiningRoundedIcon />}
        sx={{
          mt: "auto",
          borderRadius: 2,
          py: 1.2,
          fontWeight: 800,
          borderWidth: 2,
          bgcolor: "rgba(255,255,255,0.75)",
          "&:hover": {
            borderWidth: 2,
            bgcolor: "rgba(255,247,237,0.95)",
          },
        }}
      >
        View Recipe
      </Button>
    </CardContent>
  </Card>
);

export default RecipeCard;
